<template>
  <div>
    <b-container fluid class="content">
      <b-row class="mt-4" v-if="currpage == 'list'">
        <b-col>
          <b-card>
            <div class="p-3" v-if="storelist">
              <div>{{ $t('Online Store') }} <el-button type="primary" class="ml-6" size="small" @click="back_to_store">{{ $t("Back") }}</el-button></div>
              <el-table
                stripe
                class="table-responsive table"
                header-row-class-name="thead-light"
                :data="storelist"
                @row-click="row_clicked_event"
              >
                <el-table-column label="ID" prop="IDn">
                  <template v-slot:row>
                    {{ row.IDn }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('Store')" prop="LocationID">
                </el-table-column>
                <el-table-column :label="$t('Type')">
                  <template slot-scope="scope">
                    {{ getSourceName(scope.row.SourceType) }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('Name')" prop="SourceName">
                </el-table-column>
                <el-table-column :label="$t('Status')">
                  <template slot-scope="scope">
                    <div v-if="scope.row.Status==0">{{ $t("Close") }}</div>
                    <div v-else>{{ $t("Open_Store") }}</div>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('Status')">
                  <template slot="header">
                    <i @click="add_store()" class="el-icon-circle-plus float-right mt-1 mr-6" style="color: #409eff"></i>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row class="mt-4" v-else>
        <b-col>
          <b-card no-body>
            <b-card-body>
              <b-form>
                <b-row class="border-bottom mb-2">
                  <b-col cols="4">
                    <b-row>
                      <b-col class="col-5 font-weight-bold text-sm-right">
                        {{ $t('Store') }}
                      </b-col>
                      <b-col class="col-7">
                        {{ cur_store.LocationID }} <span v-if="cur_store.IDn"> -- {{ cur_store.IDn }}</span>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="4">
                    <b-row>
                      <b-col class="col-5 font-weight-bold text-sm-right">
                        {{ $t('Store Type') }}
                      </b-col>
                      <b-col class="col-7">
                        <select class="form-control input_height_1_5" v-model="cur_store.SourceType" @change="changedSourceType">
                          <!-- <option value="pandaraw">Panda Direct</option> -->
                          <option value="pandaapi">{{ getSourceName("pandaapi") }}</option>
                          <option value="poskingh5">{{ getSourceName("poskingh5") }}</option>
                          <option value="pkh5">{{ getSourceName("pkh5") }}</option>
                          <option value="ubereat">{{ getSourceName("ubereat") }}</option>
                          <option value="fantuan">{{ getSourceName("fantuan") }}</option>
                        </select>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="4">
                    <b-row>
                      <b-col class="col-5 font-weight-bold text-sm-right">
                        {{ $t('Status') }}
                      </b-col>
                      <b-col class="col-1">
                      </b-col>
                      <b-col class="col-2">
                        <input
                          class="form-check-input"
                          type="radio"
                          v-model="cur_store.Status"
                          id="inlineRadio2"
                          value="0"
                        />
                        <label class="form-check-label" for="inlineRadio1">{{
                          $t("Close")
                        }}</label>
                      </b-col>
                      <b-col class="col-2">
                        <input
                          class="form-check-input"
                          type="radio"
                          v-model="cur_store.Status"
                          id="inlineRadio2"
                          value="1"
                        />
                        <label class="form-check-label" for="inlineRadio2">{{
                          $t("Open_Store")
                        }}</label>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row v-if="cur_store.SourceType!='pkh5'" class="border-bottom mb-2">
                  <b-col cols="4">
                    <b-row>
                      <b-col class="col-5 font-weight-bold text-sm-right">
                        <div class="form-control-label">
                          {{ $t('Store Name') }}
                        </div>
                      </b-col>
                      <b-col class="col-7">
                        <b-input
                          placeholder="Store Name"
                          class="form-control input_height_1_5"
                          v-model="cur_store.SourceName"
                        />
                        <p>your store name for api server</p>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="4">
                    <b-row>
                      <b-col class="col-5 font-weight-bold text-sm-right">
                        <div class="form-control-label">
                          {{ $t('Secure Key') }}
                        </div>
                      </b-col>
                      <b-col class="col-7">
                        <b-input
                          placeholder="Secure Key"
                          class="form-control input_height_1_5"
                          v-model="cur_store.SecureKey"
                          :disabled="cur_store.SourceType != 'poskingh5'"
                        />
                        <p>secure key for api server</p>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="4">
                    <b-row>
                      <b-col class="col-5 font-weight-bold text-sm-right">
                        PosKing API URL
                      </b-col>
                      <b-col class="col-7">
                        <b-input
                          placeholder="URL"
                          class="form-control input_height_1_5"
                          v-model="cur_store.SourceURL"
                        />
                        <p>change only if you need</p>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row v-if="cur_store.SourceType=='ubereat'" class="border-bottom mb-2">
                  <b-col cols="4">
                    <b-row>
                      <b-col class="col-5 font-weight-bold text-sm-right">
                        <div class="form-control-label">
                          Uber Eat Store ID
                        </div>
                      </b-col>
                      <b-col class="col-7">
                        <b-input
                          placeholder="Store Unique ID"
                          class="form-control input_height_1_5"
                          v-model="UberEatStoreID"
                          disabled
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                  <!-- <b-col cols="4">
                    <b-row>
                      <b-col class="col-5 font-weight-bold text-sm-right">
                        <div class="form-control-label">
                          Uber Eat Access Token
                        </div>
                      </b-col>
                      <b-col class="col-7">
                        <b-input
                          placeholder="Secure Key"
                          class="form-control input_height_1_5"
                          v-model="UberAccessToken"
                          disabled
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="4">
                    <b-row>
                      <b-col class="col-5 font-weight-bold text-sm-right">
                        <div class="form-control-label">
                          Uber Eat Refresh Token
                        </div>
                      </b-col>
                      <b-col class="col-7">
                        <b-input
                          placeholder="Secure Key"
                          class="form-control input_height_1_5"
                          v-model="UberRefreshToken"
                          disabled
                        />
                      </b-col>
                    </b-row>
                  </b-col> -->
                </b-row>
                <b-row v-else-if="cur_store.SourceType=='fantuan'" class="border-bottom mb-2">
                  <b-col cols="4">
                    <b-row>
                      <b-col class="col-5 font-weight-bold text-sm-right">
                        <div class="form-control-label">
                          Fantuan Store ID
                        </div>
                      </b-col>
                      <b-col class="col-7">
                        <b-input
                          placeholder="Fantuan Store ID"
                          class="form-control input_height_1_5"
                          v-model="FantuanStoreID"
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row v-else-if="cur_store.SourceType=='pandaapi'" class="border-bottom mb-2">
                  <b-col cols="4">
                    <b-row>
                      <b-col class="col-5 font-weight-bold text-sm-right">
                        <div class="form-control-label">
                          Panda Store ID
                        </div>
                      </b-col>
                      <b-col class="col-7">
                        <b-input
                          placeholder="Store ID"
                          class="form-control input_height_1_5"
                          v-model="PandaStoreID"
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="4">
                    <b-row>
                      <b-col class="col-5 font-weight-bold text-sm-right">
                        <div class="form-control-label">
                          Panda Store Access Key
                        </div>
                      </b-col>
                      <b-col class="col-7">
                        <b-input
                          placeholder="Access Key"
                          class="form-control input_height_1_5"
                          v-model="PandaAccessKey"
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="4">
                    <b-row>
                      <b-col class="col-5 font-weight-bold text-sm-right">
                        <div class="form-control-label">
                          Panda Store Security Key
                        </div>
                      </b-col>
                      <b-col class="col-7">
                        <b-input
                          placeholder="Security Key"
                          class="form-control input_height_1_5"
                          v-model="SecurityKey"
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row v-else-if="cur_store.SourceType=='pkh5'" class="border-bottom mb-2">
                  <b-col cols="3">
                    <b-row>
                      <b-col>
                        <div class="">
                          H5 Logo
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col class="">
                        <b-form-file id='image_logo' v-model="Logo" accept="image/*" @change="onLogoFileChange" label="Choose an image"></b-form-file>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col v-if="LogoPreview" class="">
                        <b-img :src="LogoPreview" alt="Logo Preview" fluid />
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="3">
                    <b-row>
                      <b-col>
                        <div class="">
                          H5 {{ $t('Splash Page Background Image') }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col class="">
                        <b-form-file id='image_back_image' v-model="BackImage" accept="image/*" @change="onBackImageFileChange" label="Choose an image"></b-form-file>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col v-if="BackImagePreview" class="">
                        <b-img :src="BackImagePreview" alt="Back Image Preview" fluid />
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="3">
                    <b-row>
                      <b-col class="">
                        <b-form-group :label="'H5' + ' ' + $t('Primary Color')">
                          <div class="h5-theme-color-field">
                            <b-input
                              type="color"
                              class="form-control input_height_1_5 h5-theme-color-input"
                              v-model="h5Settings.theme_primary_color"
                              @input="markH5ThemeCustom"
                            />
                            <b-input
                              class="form-control input_height_1_5 h5-theme-hex-input"
                              v-model="h5Settings.theme_primary_color"
                              @input="markH5ThemeCustom"
                            />
                          </div>
                        </b-form-group>
                      </b-col>
                      <b-col class="">
                        <b-form-group :label="'H5' + ' ' + $t('Secondary Color')">
                          <div class="h5-theme-color-field">
                            <b-input
                              type="color"
                              class="form-control input_height_1_5 h5-theme-color-input"
                              v-model="h5Settings.theme_secondary_color"
                              @input="markH5ThemeCustom"
                            />
                            <b-input
                              class="form-control input_height_1_5 h5-theme-hex-input"
                              v-model="h5Settings.theme_secondary_color"
                              @input="markH5ThemeCustom"
                            />
                          </div>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="3">
                    <b-form-group :label="'H5' + ' ' + $t('Theme')">
                      <select
                        class="form-control input_height_1_5"
                        v-model="h5Settings.theme_template"
                        @change="applyH5ThemeTemplate"
                      >
                        <option
                          v-for="template in h5ThemeTemplates"
                          :key="template.value"
                          :value="template.value"
                        >
                          {{ template.text }}
                        </option>
                      </select>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-row class="mt-2">
                      <b-col cols="12">
                        <b-row>
                          <b-col cols="6">
                            <b-form-group :label="$t('Announcement')">
                              <b-input
                                placeholder="Announcement"
                                class="form-control input_height_1_5"
                                v-model="h5Settings.announcement"
                              />
                            </b-form-group>
                          </b-col>
                          <b-col cols="6">
                          </b-col>
                        </b-row>
                        <b-row class="mt-1">
                          <b-col cols="12">
                            <b-form-checkbox
                              v-model="h5Settings.search_enabled"
                              :value="1"
                              :unchecked-value="0"
                              inline
                            >
                              {{ $t('Enable Search') }}
                            </b-form-checkbox>
                            <b-form-checkbox
                              v-model="h5Settings.item_note_enabled"
                              :value="1"
                              :unchecked-value="0"
                              inline
                            >
                              {{ $t('Enable Item Note') }}
                            </b-form-checkbox>
                            <b-form-checkbox
                              v-model="h5Settings.order_note_enabled"
                              :value="1"
                              :unchecked-value="0"
                              inline
                            >
                              {{ $t('Enable Order Note') }}
                            </b-form-checkbox>
                            <b-form-checkbox
                              v-model="h5Settings.show_images"
                              :value="1"
                              :unchecked-value="0"
                              inline
                            >
                              {{ $t('Show Images') }}
                            </b-form-checkbox>
                            <b-form-checkbox
                              v-model="h5Settings.ow_login"
                              :value="1"
                              :unchecked-value="0"
                              inline
                            >
                              {{ $t('Enable') }} OW {{ $t('Login') }}
                            </b-form-checkbox>
                          </b-col>
                        </b-row>
                        <b-row class="mt-1">
                          <b-col cols="12">
                            <b-form-checkbox
                              v-model="h5Settings.order_notice_enabled"
                              :value="1"
                              :unchecked-value="0"
                              inline
                            >
                              {{ $t("Order Popup Window") }}
                            </b-form-checkbox>
                          </b-col>
                          <b-col cols="6" class="mt-2">
                            <b-form-group :label="$t('Order Popup Window Content') + '1'">
                              <b-input
                                :placeholder="$t('Order Popup Window Content') + '1'"
                                class="form-control input_height_1_5"
                                v-model="h5Settings.order_notice_text1"
                                maxlength="300"
                              />
                            </b-form-group>
                          </b-col>
                          <b-col cols="6" class="mt-2">
                            <b-form-group :label="$t('Order Popup Window Content') + '2'">
                              <b-input
                                :placeholder="$t('Order Popup Window Content') + '2'"
                                class="form-control input_height_1_5"
                                v-model="h5Settings.order_notice_text2"
                                maxlength="300"
                              />
                            </b-form-group>
                          </b-col>
                        </b-row>
                        <b-row class="mt-1">
                          <b-col cols="12">
                            <b-form-checkbox
                              v-model="h5Settings.order_status_sms_enabled"
                              :value="1"
                              :unchecked-value="0"
                              inline
                            >
                              {{ $t('Enable SMS for accepted / rejected orders') }}
                            </b-form-checkbox>
                          </b-col>
                        </b-row>
                        <b-row class="mt-1">
                          <b-col cols="12">
                            <b-form-checkbox
                              v-model="h5Settings.phone_required_dinein"
                              :value="1"
                              :unchecked-value="0"
                              inline
                            >
                              {{ $t('Phone required for dine-in') }}
                            </b-form-checkbox>
                            <b-form-checkbox
                              v-model="h5Settings.phone_required_takeaway"
                              :value="1"
                              :unchecked-value="0"
                              inline
                            >
                              {{ $t('Phone required for pickup') }}
                            </b-form-checkbox>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                    <b-row class="border-top mt-2 pt-2">
                      <b-col cols="12" class="font-weight-bold">
                        {{ $t('Order Modes') }}
                      </b-col>
                    </b-row>
                    <b-row id="order_modes" class="mt-2">
                      <b-col :cols="orderTypes.Pickup ? 4 : 12">
                        <b-form-checkbox
                          v-for="option in orderTypeOptions"
                          :key="option.value"
                          v-model="orderTypes[option.value]"
                          :value="1"
                          :unchecked-value="0"
                          inline
                        >
                          {{ $t(option.text) }}
                        </b-form-checkbox>
                      </b-col>
                      <b-col v-if="orderTypes.Pickup" cols="8">
                        <b-row>
                          <b-col class="col-5 font-weight-bold text-sm-right">
                            {{ $t('Pickup Default Table') }}
                          </b-col>
                          <b-col class="col-7">
                            <select
                              class="form-control input_height_1_5"
                              v-model="h5Settings.pickup_default_table"
                            >
                              <option value="0">{{ $t('Select Table') }}</option>
                              <option v-for="table in tableList" :key="table.IDn" :value="table.IDn">
                                {{ table.Name }}
                              </option>
                            </select>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                    <b-row class="border-top mt-2 pt-2">
                      <b-col cols="12" class="font-weight-bold">
                        {{ $t('Payment Processors') }}
                      </b-col>
                    </b-row>
                    <b-row id="counter" class="mt-2">
                      <b-col cols="4">
                        <b-form-checkbox
                          v-model="paymentProcessors.Counter.Status"
                          :value="1"
                          :unchecked-value="0"
                        >
                          {{ $t('Enable pay at Counter') }}
                        </b-form-checkbox>
                      </b-col>
                    </b-row>
                    <b-row id="global_payment" class="border-top mt-2 mb-2 pt-2">
                      <b-col cols="4">
                        <b-form-checkbox
                          v-model="paymentProcessors.GlobalPayment.Status"
                          :value="1"
                          :unchecked-value="0"
                        >
                          {{ $t('Enable') }} GlobalPayment
                        </b-form-checkbox>
                        <b-form-checkbox
                          v-model="paymentProcessors.GlobalPayment.inTesting"
                          :value="1"
                          :unchecked-value="0"
                          :disabled="paymentProcessors.GlobalPayment.Status != 1"
                        >
                          {{ $t('In Testing') }}
                        </b-form-checkbox>
                      </b-col>
                      <b-col cols="8">
                        <b-row>
                          <b-col cols="4">
                            <b-input
                              placeholder="Merchant ID"
                              class="form-control input_height_1_5"
                              v-model="paymentProcessors.GlobalPayment.processorData.merchantId"
                              :disabled="paymentProcessors.GlobalPayment.Status != 1"
                            />
                          </b-col>
                          <b-col cols="4">
                            <b-input
                              placeholder="Account ID"
                              class="form-control input_height_1_5"
                              v-model="paymentProcessors.GlobalPayment.processorData.accountId"
                              :disabled="paymentProcessors.GlobalPayment.Status != 1"
                            />
                          </b-col>
                          <b-col cols="4">
                            <b-input
                              placeholder="Shared Secret"
                              class="form-control input_height_1_5"
                              v-model="paymentProcessors.GlobalPayment.processorData.sharedSecret"
                              :disabled="paymentProcessors.GlobalPayment.Status != 1"
                            />
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row class="justify-content-lg-center mt-3">
                  <b-col cols="4">
                    <b-row>
                      <b-col class="col-5 font-weight-bold text-sm-right">
                        Menu
                      </b-col>
                      <b-col class="col-7">
                        <select class="form-control input_height_1_5" v-model="Menu_IDn">
                          <option v-for="menu in menuList" :key="menu.IDn" :value="menu.IDn">{{ menu.Name1 }}</option>
                        </select>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col v-if="cur_store.SourceType=='poskingh5'" cols="4">
                    <b-row>
                      <b-col class="col-5 font-weight-bold text-sm-right">
                        <div class="form-control-label">
                          Store Access Key
                        </div>
                      </b-col>
                      <b-col class="col-7">
                        <b-input
                          placeholder="Access Key"
                          class="form-control input_height_1_5"
                          v-model="SecurityKey"
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col v-else cols="4">
                  </b-col>
                  <b-col cols="4">
                    <b-row>
                      <b-col class="col-5 font-weight-bold text-sm-right">
                        {{ $t('Auto-Confirm') }}
                      </b-col>
                      <b-col class="col-1">
                      </b-col>
                      <b-col class="col-2">
                        <input
                          class="form-check-input"
                          type="radio"
                          v-model="AutoConfirm"
                          id="inlineRadio2"
                          value="0"
                        />
                        <label class="form-check-label" for="inlineRadio1">{{
                          $t("No")
                        }}</label>
                      </b-col>
                      <b-col class="col-2">
                        <input
                          class="form-check-input"
                          type="radio"
                          v-model="AutoConfirm"
                          id="inlineRadio2"
                          value="1"
                        />
                        <label class="form-check-label" for="inlineRadio2">{{
                          $t("Yes")
                        }}</label>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row v-if="cur_store.SourceType=='pkh5'" class="justify-content-lg-center mt-3">
                  <b-col cols="4" class="text-center">
                    <el-button type="primary" size="small" @click="go_to_h5_store_hour">Set Store Hours & Menu</el-button>
                  </b-col>
                  <b-col cols="4" class="text-center">
                    <el-button type="primary" size="small" @click="go_to_h5_set_table">Set H5 Tables</el-button>
                  </b-col>
                  <b-col cols="4" class="text-center">
                    <el-button type="primary" size="small" @click="send_h5_store_info">Send Info to H5 Store</el-button>
                  </b-col>
                </b-row>
                <b-row v-if="(cur_store.SourceType=='ubereat')&&cur_store.SourceParameter" class="justify-content-lg-center mt-3">
                  <b-col class="text-center">
                    <b-row>
                      <b-col class="text-center">
                        <el-button type="primary" @click="uber_integration('activate')">Activate Integration</el-button>
                      </b-col>
                      <b-col class="text-center">
                        <el-button type="primary" @click="uber_integration('remove')">Remove Integration</el-button>
                      </b-col>
                      <b-col class="text-center">
                        <el-button type="primary" @click="uber_integration('get')">Get Integration Details</el-button>
                      </b-col>
                      <b-col class="text-center">
                        <el-button type="primary" @click="uber_integration('update')">Update Integration Details</el-button>
                      </b-col>
                    </b-row>
                    <b-row class="mt-2">
                      <b-col class="text-center">
                        <el-button type="primary" @click="get_store_detail">Get UberEat Store Status</el-button>
                      </b-col>
                      <b-col class="text-center">
                        <el-button type="primary" @click="show_store_status_input">Set UberEat Store Status</el-button>
                      </b-col>
                      <b-col class="text-center">
                        <el-button type="primary" @click="show_input_date_time">Update Holiday Hours</el-button>
                      </b-col>
                      <b-col class="text-center">
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row class="justify-content-lg-center mt-5">
                  <b-col class="text-center">
                    <el-button type="primary" @click="form_cancel">{{ $t("Back")}}</el-button>
                  </b-col>
                  <b-col v-if="(cur_store.SourceType!='pkh5')&&(cur_store.SourceType!='poskingh5')" class="text-center">
                    <div v-if="cur_store.SourceParameter">
                      <el-button type="primary" @click="upload_online_menu" :disabled="cur_store.IDn==0">Update Online Menu</el-button>
                      <p>Upload Store Menu ...</p>
                    </div>
                  </b-col>
                  <b-col v-if="(cur_store.SourceType!='pkh5')&&(cur_store.SourceType!='poskingh5')" class="text-center">
                    <div v-if="cur_store.SourceParameter">
                      <el-button type="primary" @click="get_api_info" :disabled="cur_store.IDn==0">Get Store Status</el-button>
                      <p>Check Store Connection ...</p>
                    </div>
                    <div v-else-if="cur_store.SourceType=='ubereat'">
                      <form action="https://sandbox-login.uber.com/oauth/v2/authorize" method="GET" target="_blank" ref="myForm">
                        <input type="hidden" name="response_type" value="code" />
                        <input type="hidden" name="scope" value="eats.pos_provisioning" />
                        <input type="hidden" name="client_id" value="hC4qW8rekfntxZux6EOi3KRSm9HUygRo" />
                        <input type="hidden" name="redirect_uri" v-model="redirct_uri" />
                        <el-button type="primary" @click="connet_uber">
                          <span>Connect My Uber Eat Store</span>
                        </el-button>
                      </form>
                    </div>
                  </b-col>
                  <b-col class="text-center" v-if="(cur_store.IDn!=0)&&(cur_store.SourceType!='poskingh5')&&(cur_store.SourceType!='pkh5')">
                    <el-button type="primary" @click="updateApiStore(cur_store.LocationID, cur_store.SourceType)" :disabled="cur_store.IDn==0">Update API Server</el-button>
                    <p v-if="showUpdatedStore">Finished to upload Store data to API server</p>
                  </b-col>
                  <b-col class="text-center">
                    <el-button type="primary" @click="form_submit">{{ $t("Submit") }}</el-button>
                  </b-col>
                </b-row>
              </b-form>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
      <b-row class="mt-4" v-if="text_message">
        <b-col>
          <b-card no-body>
            {{ text_message }}
          </b-card>
        </b-col>
      </b-row>
      <b-modal v-model="showDateHourInput" title="Holiyday Date and Time" hide-footer size="lg">
        <b-row v-for="(timeSlot, index) in timeSlots" :key="index" >
          <b-col cols="4">
            <b-form-group :label="'Input Date ' + (index + 1)">
              <b-form-input
                type="date"
                v-model="timeSlot.date"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group :label="'Start Time ' + (index + 1)">
              <b-form-select
                v-model="timeSlot.startTime"
                :options="timeOptions"
                @change="verify_input_time(timeSlot,'s')"
                required
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group :label="'End Time ' + (index + 1)">
              <b-form-select
                v-model="timeSlot.endTime"
                :options="timeOptions"
                @change="verify_input_time(timeSlot, 'e')"
                required
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-button @click="addTimeSlot" variant="primary">Add Another Time Slot</b-button>
          </b-col>
          <b-col>
            <b-button @click="uber_update_hours" variant="success">Submit</b-button>
          </b-col>
        </b-row>
      </b-modal>
      <b-modal v-model="showIntegrationInput" title="Update Integration Details" hide-footer size="lg">
        <b-form @submit.prevent="submit_uber_integration_update">
          <b-form-group label="Email">
            <b-form-input v-model.trim="integrationForm.email" type="email" required></b-form-input>
          </b-form-group>
          <b-form-group label="Name">
            <b-form-input v-model.trim="integrationForm.name" required></b-form-input>
          </b-form-group>
          <b-form-group label="Phone Number">
            <b-form-input v-model.trim="integrationForm.phone_number" required></b-form-input>
          </b-form-group>
          <b-form-group label="Pickup Instructions">
            <b-form-textarea v-model.trim="integrationForm.pickup_instructions" rows="3" required></b-form-textarea>
          </b-form-group>
          <b-row>
            <b-col>
              <b-button @click="showIntegrationInput = false" variant="secondary">Cancel</b-button>
            </b-col>
            <b-col class="text-right">
              <b-button type="submit" variant="success" :disabled="!isIntegrationFormValid">Update</b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-modal>
      <b-modal v-model="showStoreDetailPopup" title="Store API Info" hide-footer size="lg">
        <pre class="store-detail-content">{{ storeDetailContent }}</pre>
        <b-row>
          <b-col class="text-right">
            <b-button @click="showStoreDetailPopup = false" variant="secondary">Close</b-button>
          </b-col>
        </b-row>
      </b-modal>
      <b-modal v-model="showStoreStatusInput" title="Set Store Status" hide-footer>
        <b-form @submit.prevent="submit_store_status">
          <b-form-group label="Status">
            <b-form-select
              v-model="storeStatusForm.status"
              :options="storeStatusOptions"
              required
            ></b-form-select>
          </b-form-group>
          <b-form-group label="Reason">
            <b-form-input v-model.trim="storeStatusForm.reason" required></b-form-input>
          </b-form-group>
          <b-form-group label="Offline Until" v-if="storeStatusForm.status == 'OFFLINE'">
            <b-form-input v-model="storeStatusForm.is_offline_until" type="datetime-local" required></b-form-input>
          </b-form-group>
          <b-row>
            <b-col>
              <b-button @click="showStoreStatusInput = false" variant="secondary">Cancel</b-button>
            </b-col>
            <b-col class="text-right">
              <b-button type="submit" variant="success" :disabled="!isStoreStatusFormValid">Update</b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-modal>
    </b-container>
    <div class="loading-overlay" v-if="show_loading">
      <div class="spinner"></div>
      <p>Loading...</p>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Button, DatePicker, } from "element-ui";
import { getStore, setStore } from "../../util/helper";
import { hasUtilityAuth } from "../../directives/acl";

const axios = require("axios");

export default {
  components: {
    [DatePicker.name]: DatePicker,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
  },
  data() {
    return {
      show_loading: false,
      currpage: "list",
      new_store: {
        IDn: 0,
        LocationID: '',
        SourceType: "pandaraw", // pandaraw, pandaapi, ubereat, fantuan
        SourceName: "",
        Status: 1,
        SecureKey: "",
        SourceURL: "https://api.posking.ca/Api",
        SourceParameter: "",
        LocalParameter: "",
      },
      storelist: null,
      cur_store: {},
      menuList: null,
      Menu_IDn: 0,
      tableList: null,
      Table_IDn: 0,
      AutoConfirm: 0,

      UberEatStoreID: "",
      UberAccessToken: "",
      UberRefreshToken: "",
      redirct_uri: "",

      PandaStoreID: "",
      PandaAccessKey: "",
      SecurityKey: "",
      FantuanStoreID: "",
      orderTypes: {
        Dinein: 1,
        Pickup: 0,
      },
      orderTypeOptions: [
        { text: "Dinein", value: "Dinein" },
        { text: "Pickup", value: "Pickup" },
      ],
      h5ThemeTemplates: [
        { text: "Custom", value: "custom" },
        { text: "Forest & Apricot (#355C4A / #D99067)", value: "forest_apricot", primary: "#355C4A", secondary: "#D99067" },
        { text: "Cobalt & Saffron (#315A78 / #D5A247)", value: "cobalt_saffron", primary: "#315A78", secondary: "#D5A247" },
        { text: "Plum & Rose (#65445D / #D58C91)", value: "plum_rose", primary: "#65445D", secondary: "#D58C91" },
        { text: "Terracotta & Sage (#A95645 / #8FA58A)", value: "terracotta_sage", primary: "#A95645", secondary: "#8FA58A" },
        { text: "Cocoa & Lavender (#72584C / #A997B8)", value: "cocoa_lavender", primary: "#72584C", secondary: "#A997B8" },
      ],
      h5Settings: {
        announcement: "",
        theme_template: "custom",
        theme_primary_color: "#25483B",
        theme_secondary_color: "#F16522",
        search_enabled: 1,
        item_note_enabled: 1,
        order_note_enabled: 1,
        phone_required_dinein: 0,
        phone_required_takeaway: 1,
        show_images: 1,
        ow_login: 0,
        order_notice_enabled: 0,
        order_notice_text1: "",
        order_notice_text2: "",
        order_status_sms_enabled: 0,
        pickup_default_table: 0,
      },
      h5SettingsRaw: {},
      paymentProcessors: {
        Counter: {
          processorType: "Counter",
          Status: 0,
          processorData: {},
        },
        GlobalPayment: {
          processorType: "GlobalPayment",
          Status: 0,
          inTesting: 1,
          processorData: {
            merchantId: "",
            accountId: "",
            sharedSecret: "",
            environment: "TEST",
            hppUrl: "https://pay.sandbox.realexpayments.com/pay",
          },
        },
      },

      Logo: null,
      LogoPreview: null,
      BackImage: null,
      BackImagePreview: null,
      Slide1: null,
      Slide1Preview: null,
      Slide2: null,
      Slide2Preview: null,
      Slide3: null,
      Slide3Preview: null,
      showUpdatedStore: false,

      token: "",
      user_id: 0,

      text_message: "",
      uber_test_counter: 0,

      showDateHourInput: false,
      showIntegrationInput: false,
      showStoreStatusInput: false,
      showStoreDetailPopup: false,
      storeDetailContent: "",
      integrationForm: {
        email: "",
        name: "",
        phone_number: "",
        pickup_instructions: "",
      },
      storeStatusForm: {
        status: "ONLINE",
        reason: "",
        is_offline_until: "",
      },
      storeStatusOptions: [
        { value: "ONLINE", text: "ONLINE" },
        { value: "OFFLINE", text: "OFFLINE" },
      ],
      timeSlots: [
      ],
      newSlot: {
        date: '',
        startTime: '',
        endTime: ''
      },
      timeOptions:[
        { value: "00:00", text: "00:00" },
        { value: "00:15", text: "00:15" },
        { value: "00:30", text: "00:30" },
        { value: "00:45", text: "00:45" },
        { value: "01:00", text: "01:00" },
        { value: "01:15", text: "01:15" },
        { value: "01:30", text: "01:30" },
        { value: "01:45", text: "01:45" },
        { value: "02:00", text: "02:00" },
        { value: "02:15", text: "02:15" },
        { value: "02:30", text: "02:30" },
        { value: "02:45", text: "02:45" },
        { value: "03:00", text: "03:00" },
        { value: "03:15", text: "03:15" },
        { value: "03:30", text: "03:30" },
        { value: "03:45", text: "03:45" },
        { value: "04:00", text: "04:00" },
        { value: "04:15", text: "04:15" },
        { value: "04:30", text: "04:30" },
        { value: "04:45", text: "04:45" },
        { value: "05:00", text: "05:00" },
        { value: "05:15", text: "05:15" },
        { value: "05:30", text: "05:30" },
        { value: "05:45", text: "05:45" },
        { value: "06:00", text: "06:00" },
        { value: "06:15", text: "06:15" },
        { value: "06:30", text: "06:30" },
        { value: "06:45", text: "06:45" },
        { value: "07:00", text: "07:00" },
        { value: "07:15", text: "07:15" },
        { value: "07:30", text: "07:30" },
        { value: "07:45", text: "07:45" },
        { value: "08:00", text: "08:00" },
        { value: "08:15", text: "08:15" },
        { value: "08:30", text: "08:30" },
        { value: "08:45", text: "08:45" },
        { value: "09:00", text: "09:00" },
        { value: "09:15", text: "09:15" },
        { value: "09:30", text: "09:30" },
        { value: "09:45", text: "09:45" },
        { value: "10:00", text: "10:00" },
        { value: "10:15", text: "10:15" },
        { value: "10:30", text: "10:30" },
        { value: "10:45", text: "10:45" },
        { value: "11:00", text: "11:00" },
        { value: "11:15", text: "11:15" },
        { value: "11:30", text: "11:30" },
        { value: "11:45", text: "11:45" },
        { value: "12:00", text: "12:00" },
        { value: "12:15", text: "12:15" },
        { value: "12:30", text: "12:30" },
        { value: "12:45", text: "12:45" },
        { value: "13:00", text: "13:00" },
        { value: "13:15", text: "13:15" },
        { value: "13:30", text: "13:30" },
        { value: "13:45", text: "13:45" },
        { value: "14:00", text: "14:00" },
        { value: "14:15", text: "14:15" },
        { value: "14:30", text: "14:30" },
        { value: "14:45", text: "14:45" },
        { value: "15:00", text: "15:00" },
        { value: "15:15", text: "15:15" },
        { value: "15:30", text: "15:30" },
        { value: "15:45", text: "15:45" },
        { value: "16:00", text: "16:00" },
        { value: "16:15", text: "16:15" },
        { value: "16:30", text: "16:30" },
        { value: "16:45", text: "16:45" },
        { value: "17:00", text: "17:00" },
        { value: "17:15", text: "17:15" },
        { value: "17:30", text: "17:30" },
        { value: "17:45", text: "17:45" },
        { value: "18:00", text: "18:00" },
        { value: "18:15", text: "18:15" },
        { value: "18:30", text: "18:30" },
        { value: "18:45", text: "18:45" },
        { value: "19:00", text: "19:00" },
        { value: "19:15", text: "19:15" },
        { value: "19:30", text: "19:30" },
        { value: "19:45", text: "19:45" },
        { value: "20:00", text: "20:00" },
        { value: "20:15", text: "20:15" },
        { value: "20:30", text: "20:30" },
        { value: "20:45", text: "20:45" },
        { value: "21:00", text: "21:00" },
        { value: "21:15", text: "21:15" },
        { value: "21:30", text: "21:30" },
        { value: "21:45", text: "21:45" },
        { value: "22:00", text: "22:00" },
        { value: "22:15", text: "22:15" },
        { value: "22:30", text: "22:30" },
        { value: "22:45", text: "22:45" },
        { value: "23:00", text: "23:00" },
        { value: "23:15", text: "23:15" },
        { value: "23:30", text: "23:30" },
        { value: "23:45", text: "23:45" },
        { value: "23:59", text: "23:59" },
      ],
    };
  },
  methods: {
    hasUtilityAuth,
    setOrderTypes(orderTypes) {
      let defaults = {
        Dinein: 1,
        Pickup: 0,
      };
      if (typeof orderTypes === "string" && orderTypes) {
        try {
          orderTypes = JSON.parse(orderTypes);
        } catch (e) {
          orderTypes = {};
        }
      }
      if (!orderTypes || typeof orderTypes !== "object") {
        this.orderTypes = defaults;
        return;
      }
      if (Array.isArray(orderTypes)) {
        let converted = Object.assign({}, defaults);
        orderTypes.forEach(function (orderType) {
          if (orderType === "DineIn") {
            orderType = "Dinein";
          } else if (orderType === "TakeOut") {
            orderType = "Pickup";
          }
          if (converted.hasOwnProperty(orderType)) {
            converted[orderType] = 1;
          }
        });
        this.orderTypes = converted;
        return;
      }
      this.orderTypes = Object.assign({}, defaults, {
        Dinein: parseInt(orderTypes.Dinein, 10) === 1 || parseInt(orderTypes.DineIn, 10) === 1 ? 1 : 0,
        Pickup: parseInt(orderTypes.Pickup, 10) === 1 || parseInt(orderTypes.TakeOut, 10) === 1 ? 1 : 0,
      });
    },
    normalizeH5ThemeColor(color, fallback) {
      let value = String(color || "").trim();
      if (/^#[0-9a-fA-F]{6}$/.test(value)) {
        return value.toUpperCase();
      }
      if (/^[0-9a-fA-F]{6}$/.test(value)) {
        return ("#" + value).toUpperCase();
      }
      return fallback;
    },
    getH5ThemeTemplate(value) {
      return this.h5ThemeTemplates.find(function (template) {
        return template.value === value;
      });
    },
    applyH5ThemeTemplate() {
      let template = this.getH5ThemeTemplate(this.h5Settings.theme_template);
      if (!template || template.value === "custom") {
        return;
      }
      this.h5Settings.theme_primary_color = template.primary;
      this.h5Settings.theme_secondary_color = template.secondary;
    },
    markH5ThemeCustom() {
      let template = this.getH5ThemeTemplate(this.h5Settings.theme_template);
      if (!template || template.value === "custom") {
        this.h5Settings.theme_template = "custom";
        return;
      }
      if (
        template.primary !== this.h5Settings.theme_primary_color ||
        template.secondary !== this.h5Settings.theme_secondary_color
      ) {
        this.h5Settings.theme_template = "custom";
      }
    },
    setH5Settings(settings) {
      let defaults = {
        theme_template: "custom",
        theme_primary_color: "#25483B",
        theme_secondary_color: "#F16522",
        search_enabled: 1,
        item_note_enabled: 1,
        order_note_enabled: 1,
        phone_required_dinein: 0,
        phone_required_takeaway: 1,
        show_images: 1,
        ow_login: 0,
        order_notice_enabled: 0,
        order_notice_text: "",
        order_notice_text1: "",
        order_notice_text2: "",
        order_status_sms_enabled: 0,
        pickup_default_table: 0,
      };
      if (typeof settings === "string" && settings) {
        try {
          settings = JSON.parse(settings);
        } catch (e) {
          settings = {};
        }
      }
      if (!settings || typeof settings !== "object" || Array.isArray(settings)) {
        settings = {};
      }
      settings = Object.assign({}, defaults, settings);
      let primaryColor = this.normalizeH5ThemeColor(settings.theme_primary_color || settings.page_color, "#25483B");
      let secondaryColor = this.normalizeH5ThemeColor(settings.theme_secondary_color, "#F16522");
      let themeTemplate = this.getH5ThemeTemplate(settings.theme_template) ? settings.theme_template : "custom";
      let oldOrderNoticeText = settings.order_notice_text;
      let orderNoticeText1 = settings.order_notice_text1 || "";
      let orderNoticeText2 = settings.order_notice_text2 || "";
      if (!orderNoticeText1 && oldOrderNoticeText && typeof oldOrderNoticeText === "string") {
        orderNoticeText1 = oldOrderNoticeText;
      } else if (oldOrderNoticeText && typeof oldOrderNoticeText === "object") {
        orderNoticeText1 = orderNoticeText1 || oldOrderNoticeText.en || oldOrderNoticeText.Name2 || "";
        orderNoticeText2 = orderNoticeText2 || oldOrderNoticeText.zh || oldOrderNoticeText.Name1 || "";
      }
      this.h5SettingsRaw = Object.assign({}, settings);
      this.h5Settings = {
        announcement: settings.announcement || "",
        theme_template: themeTemplate,
        theme_primary_color: primaryColor,
        theme_secondary_color: secondaryColor,
        search_enabled: settings.search_enabled ? 1 : 0,
        item_note_enabled: settings.item_note_enabled ? 1 : 0,
        order_note_enabled: settings.order_note_enabled ? 1 : 0,
        phone_required_dinein: settings.phone_required_dinein ? 1 : 0,
        phone_required_takeaway: settings.phone_required_takeaway ? 1 : 0,
        show_images: settings.show_images ? 1 : 0,
        ow_login: settings.ow_login ? 1 : 0,
        order_notice_enabled: settings.order_notice_enabled ? 1 : 0,
        order_notice_text1: Array.from(String(orderNoticeText1 || "")).slice(0, 300).join(""),
        order_notice_text2: Array.from(String(orderNoticeText2 || "")).slice(0, 300).join(""),
        order_status_sms_enabled: settings.order_status_sms_enabled ? 1 : 0,
        pickup_default_table: parseInt(settings.pickup_default_table, 10) || 0,
      };
    },
    buildH5Settings() {
      let settings = Object.assign({}, this.h5SettingsRaw, {
        announcement: this.h5Settings.announcement || "",
        theme_template: this.h5Settings.theme_template || "custom",
        theme_primary_color: this.normalizeH5ThemeColor(this.h5Settings.theme_primary_color, "#25483B"),
        theme_secondary_color: this.normalizeH5ThemeColor(this.h5Settings.theme_secondary_color, "#F16522"),
        search_enabled: this.h5Settings.search_enabled ? 1 : 0,
        item_note_enabled: this.h5Settings.item_note_enabled ? 1 : 0,
        order_note_enabled: this.h5Settings.order_note_enabled ? 1 : 0,
        phone_required_dinein: this.h5Settings.phone_required_dinein ? 1 : 0,
        phone_required_takeaway: this.h5Settings.phone_required_takeaway ? 1 : 0,
        show_images: this.h5Settings.show_images ? 1 : 0,
        ow_login: this.h5Settings.ow_login ? 1 : 0,
        order_notice_enabled: this.h5Settings.order_notice_enabled ? 1 : 0,
        order_notice_text1: Array.from(String(this.h5Settings.order_notice_text1 || "")).slice(0, 300).join(""),
        order_notice_text2: Array.from(String(this.h5Settings.order_notice_text2 || "")).slice(0, 300).join(""),
        order_status_sms_enabled: this.h5Settings.order_status_sms_enabled ? 1 : 0,
        pickup_default_table: parseInt(this.h5Settings.pickup_default_table, 10) || 0,
      });
      delete settings.version;
      delete settings.page_color;
      delete settings.phone_required;
      delete settings.order_notice_text;
      return settings;
    },
    getDefaultPaymentProcessors() {
      return {
        Counter: {
          processorType: "Counter",
          Status: 0,
          processorData: {},
        },
        GlobalPayment: {
          processorType: "GlobalPayment",
          Status: 0,
          inTesting: 1,
          processorData: {
            merchantId: "",
            accountId: "",
            sharedSecret: "",
            environment: "TEST",
            hppUrl: "https://pay.sandbox.realexpayments.com/pay",
          },
        },
      };
    },
    setPaymentProcessors(payments) {
      let processors = this.getDefaultPaymentProcessors();
      if (typeof payments === "string" && payments) {
        try {
          payments = JSON.parse(payments);
        } catch (e) {
          payments = [];
        }
      }
      if (Array.isArray(payments)) {
        payments.forEach(function (payment) {
          if (!payment || !payment.processorType || !processors[payment.processorType]) {
            return;
          }
          processors[payment.processorType].Status = parseInt(payment.Status, 10) === 1 ? 1 : 0;
          if (payment.processorData && typeof payment.processorData === "object") {
            processors[payment.processorType].processorData = Object.assign(
              {},
              processors[payment.processorType].processorData,
              payment.processorData
            );
          }
          if (payment.processorType === "GlobalPayment") {
            processors[payment.processorType].inTesting =
              String(processors[payment.processorType].processorData.environment || "TEST").toUpperCase() === "PRODUCTION"
                ? 0
                : 1;
          }
        });
      }
      this.paymentProcessors = processors;
    },
    buildPaymentProcessors() {
      const globalPaymentInTesting = this.paymentProcessors.GlobalPayment.inTesting ? 1 : 0;
      const globalPaymentEnvironment = globalPaymentInTesting ? "TEST" : "PRODUCTION";
      const globalPaymentHppUrl = globalPaymentInTesting
        ? "https://pay.sandbox.realexpayments.com/pay"
        : "https://pay.realexpayments.com/pay";
      return [
        {
          processorType: "Counter",
          Status: this.paymentProcessors.Counter.Status ? 1 : 0,
          processorData: {},
        },
        {
          processorType: "GlobalPayment",
          Status: this.paymentProcessors.GlobalPayment.Status ? 1 : 0,
          processorData: {
            merchantId: this.paymentProcessors.GlobalPayment.processorData.merchantId || "",
            accountId: this.paymentProcessors.GlobalPayment.processorData.accountId || "",
            sharedSecret: this.paymentProcessors.GlobalPayment.processorData.sharedSecret || "",
            environment: globalPaymentEnvironment,
            hppUrl: globalPaymentHppUrl,
          },
        },
      ];
    },
    onLogoFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.LogoPreview = e.target.result; // Set the preview URL
        };
        reader.readAsDataURL(file); // Read the file as a data URL
        this.Logo = file;
      }
    },
    onSlide3FileChange(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.Slide3Preview = e.target.result; // Set the preview URL
        };
        reader.readAsDataURL(file); // Read the file as a data URL
        this.Slide3 = file;
      }
    },
    onSlide2FileChange(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.Slide2Preview = e.target.result; // Set the preview URL
        };
        reader.readAsDataURL(file); // Read the file as a data URL
        this.Slide2 = file;
      }
    },
    onSlide1FileChange(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.Slide1Preview = e.target.result; // Set the preview URL
        };
        reader.readAsDataURL(file); // Read the file as a data URL
        this.Slide1 = file;
      }
    },
    onBackImageFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.BackImagePreview = e.target.result; // Set the preview URL
        };
        reader.readAsDataURL(file); // Read the file as a data URL
        this.BackImage = file;
      }
    },
    changedSourceType() {
      if (this.cur_store.SourceType == "pandaraw") {
        this.cur_store.SourceURL = "https://api.posking.ca/Api/getMyOrders";
      } else if (this.cur_store.SourceType == "poskingh5") {
        this.cur_store.SourceURL = "https://ldwapi.posking.ca/";
      } else {
        this.cur_store.SourceURL = "https://api.posking.ca/Api";
      }
    },
    back_to_store() {
      this.$router.push("/store");
    },
    go_to_h5_store_hour() {
      if (!this.cur_store.LocationID) {
        alert("Unknown Store");
        return;
      }
      this.$router.push({
        path: "/h5_store_hours",
        query: {
          LocationID: this.cur_store.LocationID,
          OnlineSourceIDn: this.cur_store.IDn || 0,
        },
      });
    },
    go_to_h5_set_table() {
      if (!this.cur_store.LocationID) {
        alert("Unknown Store");
        return;
      }
      this.$router.push({
        path: "/h5_tables",
        query: {
          LocationID: this.cur_store.LocationID,
          OnlineSourceIDn: this.cur_store.IDn || 0,
        },
      });
    },
    async send_h5_store_info() {
      this.show_loading = true;
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("LocationID", this.cur_store.LocationID);
      bodyFormData.append("SourceType", this.cur_store.SourceType);
      var that = this;

      axios({
        method: "post",
        url: "/Api/Web/Store/updateH5ApiStore",
        data: bodyFormData,
      })
        .then(function (response) {
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              that.showUpdatedStore = true;
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          }
        })
        .catch(function (error) {
          // console.log(error);
          that.$router.push("/login");
        })
        .finally(() => {
          that.show_loading = false;
        });
    },
    add_store() {
      if (!hasUtilityAuth('StoreEdit')) return;
      this.currpage = "edit";
      this.cur_store = JSON.parse(JSON.stringify(this.new_store));
      this.cur_store.SecureKey = this.cur_store.LocationID + Date.now();
      this.text_message = "";
      // this.cur_store.LocationID = this.new_store.LocationID; // This is done at init
    },
    assign_parameters() {
      if (!this.cur_store.SecureKey) {
        this.cur_store.SecureKey = this.cur_store.LocationID + Date.now();
      }
      this.text_message = "";
      this.UberEatStoreID = "";
      this.UberAccessToken = "";
      this.UberRefreshToken = "";
      this.PandaStoreID = "";
      this.PandaAccessKey = "";
      this.SecurityKey = "";
      this.FantuanStoreID = "";
      this.setOrderTypes([]);
      this.setH5Settings({});
      this.setPaymentProcessors([]);
      if (this.cur_store.LocalParameter) {
        let ljson = JSON.parse(this.cur_store.LocalParameter);
        if (ljson.hasOwnProperty("Menu_IDn")) {
          this.Menu_IDn = ljson.Menu_IDn;
        }
        if (ljson.hasOwnProperty("Table_IDn")) {
          this.Table_IDn = ljson.Table_IDn;
        }
        if (ljson.hasOwnProperty("AutoConfirm")) {
          this.AutoConfirm = ljson.AutoConfirm;
        }
      }
      if (this.cur_store.SourceParameter && (this.cur_store.SourceParameter.length > 10)) {
        if (this.cur_store.SourceType =="ubereat") {
          let json = JSON.parse(this.cur_store.SourceParameter);
          if (json.hasOwnProperty("UberEatStoreID")) {
            this.UberEatStoreID = json.UberEatStoreID;
          }
          if (json.hasOwnProperty("UberAccessToken")) {
            this.UberAccessToken = json.UberAccessToken;
          }
          if (json.hasOwnProperty("UberRefreshToken")) {
            this.UberRefreshToken = json.UberRefreshToken;
          }
        } else if (this.cur_store.SourceType =="pandaapi") {
          let json = JSON.parse(this.cur_store.SourceParameter);
          if (json.hasOwnProperty("PandaStoreID")) {
            this.PandaStoreID = json.PandaStoreID;
          }
          if (json.hasOwnProperty("PandaAccessKey")) {
            this.PandaAccessKey = json.PandaAccessKey;
          }
          if (json.hasOwnProperty("PandaSecurityKey")) {
            this.SecurityKey = json.PandaSecurityKey;
          }
        } else if (this.cur_store.SourceType =="fantuan") {
          let json = JSON.parse(this.cur_store.SourceParameter);
          if (json.hasOwnProperty("FantuanStoreID")) {
            this.FantuanStoreID = json.FantuanStoreID;
          }
        } else if (this.cur_store.SourceType =="poskingh5") {
          let json = JSON.parse(this.cur_store.SourceParameter);
          if (json.hasOwnProperty("SecurityKey")) {
            this.SecurityKey = json.SecurityKey;
          }
        } else if (this.cur_store.SourceType =="pkh5") {
          let json = JSON.parse(this.cur_store.SourceParameter);
          if (json.hasOwnProperty("SecurityKey")) {
            this.SecurityKey = json.SecurityKey;
          }
          this.getH5Store(this.cur_store.LocationID);
        }
      } else if (this.cur_store.SourceType =="pkh5") {
        this.getH5Store(this.cur_store.LocationID);
      }
    },
    row_clicked_event(row, column, event) {
      // console.log("row_clicked_event", row, event, column);
      if (!hasUtilityAuth('StoreEdit')) return;
      this.currpage = "edit";
      this.cur_store = JSON.parse(JSON.stringify(row));
      this.assign_parameters();
    },
    form_cancel() {
      this.showUpdatedStore = false;
      this.show_loading = false;
      this.get_online_list();
    },
    async updateApiStore(LocationID, SourceType) {
      this.show_loading = true;
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("LocationID", LocationID);
      bodyFormData.append("SourceType", SourceType);
      var that = this;

      axios({
        method: "post",
        url: "/Api/Web/Store/updateApiStore",
        data: bodyFormData,
      })
        .then(function (response) {
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              that.showUpdatedStore = true;
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          }
        })
        .catch(function (error) {
          // console.log(error);
          that.$router.push("/login");
        })
        .finally(() => {
          that.show_loading = false;
        });
    },
    async getH5Store(LocationID) {
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("LocationID", LocationID);
      var that = this;

      axios({
        method: "post",
        url: "/Api/Web/Store/getH5Store",
        data: bodyFormData,
      })
        .then(function (response) {
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              let store = rt.data.store;
              that.Logo = null;
              that.LogoPreview = null;
              that.BackImage = null;
              that.BackImagePreview = null;
              that.Slide1 = null;
              that.Slide1Preview = null;
              that.Slide2 = null;
              that.Slide2Preview = null;
              that.Slide3 = null;
              that.Slide3Preview = null;
              if (store) {
                if (store.Logo) {
                  that.LogoPreview = store.Logo;
                }
                if (store.BackImage) {
                  that.BackImagePreview = store.BackImage;
                }
                if (store.Slide1) {
                  that.Slide1Preview = store.Slide1;
                }
                if (store.Slide2) {
                  that.Slide2Preview = store.Slide2;
                }
                if (store.Slide3) {
                  that.Slide3Preview = store.Slide3;
                }
                that.setOrderTypes(store.OrderTypes);
                that.setH5Settings(store.Settings);
                that.setPaymentProcessors(store.Payments);
              } else {
                that.setOrderTypes([]);
                that.setH5Settings({});
                that.setPaymentProcessors([]);
              }
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          }
        })
        .catch(function (error) {
          // console.log(error);
          that.$router.push("/login");
        });
    },
    async form_submit(event) {
      this.showUpdatedStore = false;
      if (event) {
        event.preventDefault();
      }
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      if (this.cur_store.SourceType =="ubereat") {
        // this.cur_store.SourceParameter = JSON.stringify({
        //   UberEatStoreID: this.UberEatStoreID,
        //   UberAccessToken: this.UberAccessToken,
        //   UberRefreshToken: this.UberRefreshToken,
        // });
      } else if (this.cur_store.SourceType =="pandaapi") {
        this.cur_store.SourceParameter = JSON.stringify({
          PandaStoreID: this.PandaStoreID,
          PandaAccessKey: this.PandaAccessKey,
          PandaSecurityKey: this.SecurityKey,
        });
      } else if (this.cur_store.SourceType =="fantuan") {
        this.cur_store.SourceParameter = JSON.stringify({
          FantuanStoreID: this.FantuanStoreID,
        });
      } else if (this.cur_store.SourceType =="poskingh5") {
        this.cur_store.SourceParameter = JSON.stringify({
          SecurityKey: this.SecurityKey,
        });
      } else if (this.cur_store.SourceType =="pkh5") {
        if (this.Logo) {
          bodyFormData.append("Logo", this.Logo);
        }
        if (this.BackImage) {
          bodyFormData.append("BackImage", this.BackImage);
        }
        bodyFormData.append("OrderTypes", JSON.stringify({
          Dinein: this.orderTypes.Dinein ? 1 : 0,
          Pickup: this.orderTypes.Pickup ? 1 : 0,
        }));
        bodyFormData.append("Settings", JSON.stringify(this.buildH5Settings()));
        bodyFormData.append("Payments", JSON.stringify(this.buildPaymentProcessors()));
      }
      this.cur_store.LocalParameter = JSON.stringify({
        Menu_IDn: this.Menu_IDn,
        // Table_IDn: this.Table_IDn,
        AutoConfirm: this.AutoConfirm,  // Local Pos How to receive order
      });

      for (var key in this.cur_store) {
        bodyFormData.append(key, this.cur_store[key]);
      }
      this.show_loading = true;
      var that = this;

      axios({
        method: "post",
        url: "/Api/Web/Store/updateOnlineStoreInfo",
        data: bodyFormData,
      })
        .then(function (response) {
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              // that.get_online_list();
              that.cur_store = rt.data.store;
              that.assign_parameters();
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          }
        })
        .catch(function (error) {
          that.$router.push("/login");
        })
        .finally(() => {
          that.show_loading = false;
        });
    },
    getSourceName(type) {
      if (type == "pandaapi") {
        return "Panda API";
      } else if (type == "poskingh5") {
        return "Posking LDW";
      } else if (type == "pkh5") {
        return "Posking Cloud";
      } else if (type == "ubereat") {
        return "Uber Eat";
      } else if (type == "fantuan") {
        return "Fantuan";
      } else {
        return "Unknown";
      }
    },
    async upload_online_menu(event) {
      if (event) {
        event.preventDefault();
      }
      this.show_loading = true;
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("IDn", this.cur_store.IDn);
      var that = this;

      axios({
        method: "post",
        url: "/Api/Web/Store/uploadStoreData",
        data: bodyFormData,
      })
        .then(function (response) {
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              if (rt.data && rt.data.message) {
                that.text_message = rt.data.message;
                alert(that.text_message);
              } else if (rt.message) {
                that.text_message = rt.message;
                alert(that.text_message);
              } else {
                that.text_message = "Unknown return message";
                alert(that.text_message);
              }
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          }
        })
        .catch(function (error) {
          // console.log(error);
          that.$router.push("/login");
        })
        .finally(() => {
          that.show_loading = false;
        });
    },
    uber_integration(opt) {
      if (opt == "update") {
        this.show_integration_input();
        return;
      }
      this.text_message = "";
      this.show_loading = true;
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("IDn", this.cur_store.IDn);
      bodyFormData.append("opt", opt);
      var that = this;

      axios({
        method: "post",
        url: "/Api/Web/Store/uberIntegrationAct",
        data: bodyFormData,
      })
        .then(function (response) {
          that.show_loading = false;
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              if (rt.data && rt.data.message) {
                alert(rt.data.message);
                return;
              }
              alert("Unknown return data");
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
              that.show_loading = false;
            }
          }
        })
        .catch(function (error) {
          that.show_loading = false;
          // console.log(error);
          that.$router.push("/login");
        })
    },
    show_integration_input() {
      this.integrationForm = {
        email: "",
        name: "",
        phone_number: "",
        pickup_instructions: "",
      };
      this.showIntegrationInput = true;
    },
    submit_uber_integration_update() {
      if (!this.isIntegrationFormValid) {
        alert("Please fill email, name, phone number and pickup instructions.");
        return;
      }
      this.showIntegrationInput = false;
      this.text_message = "";
      this.show_loading = true;
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("IDn", this.cur_store.IDn);
      bodyFormData.append("opt", "update");
      bodyFormData.append("email", this.integrationForm.email);
      bodyFormData.append("name", this.integrationForm.name);
      bodyFormData.append("phone_number", this.integrationForm.phone_number);
      bodyFormData.append("pickup_instructions", this.integrationForm.pickup_instructions);
      var that = this;

      axios({
        method: "post",
        url: "/Api/Web/Store/uberIntegrationAct",
        data: bodyFormData,
      })
        .then(function (response) {
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              if (rt.data && rt.data.message) {
                alert(rt.data.message);
              } else {
                alert("Unknown return data");
              }
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          }
        })
        .catch(function (error) {
          that.$router.push("/login");
        })
        .finally(() => {
          that.show_loading = false;
        });
    },
    show_store_status_input() {
      this.storeStatusForm = {
        status: "ONLINE",
        reason: "",
        is_offline_until: "",
      };
      this.showStoreStatusInput = true;
    },
    submit_store_status() {
      if (!this.isStoreStatusFormValid) {
        alert("Please fill status, reason and offline until time when required.");
        return;
      }
      this.showStoreStatusInput = false;
      this.text_message = "";
      this.show_loading = true;
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("IDn", this.cur_store.IDn);
      bodyFormData.append("status", this.storeStatusForm.status);
      bodyFormData.append("reason", this.storeStatusForm.reason);
      bodyFormData.append("dateTime", this.storeStatusForm.is_offline_until);
      var that = this;

      axios({
        method: "post",
        url: "/Api/Web/Store/uberSetStoreStatus",
        data: bodyFormData,
      })
        .then(function (response) {
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              if (rt.data && rt.data.message) {
                alert(rt.data.message);
              } else {
                alert("Status updated");
              }
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          }
        })
        .catch(function (error) {
          that.$router.push("/login");
        })
        .finally(() => {
          that.show_loading = false;
        });
    },
    show_input_date_time() {
      this.timeSlots = [];
      this.addTimeSlot();
      this.showDateHourInput = true;
    },
    addTimeSlot() {
      let tmSlot = JSON.parse(JSON.stringify(this.newSlot));
      this.timeSlots.push(tmSlot);
    },
    verify_input_time(s, p) {
      if (!s.startTime || !s.endTime) return;
      if (s.startTime > s.endTime) {
        alert("Start Time must earlier then End Time");
      }
    },
    uber_update_hours() {
      if ((this.timeSlots.length < 1) || !this.timeSlots[0].date || !this.timeSlots[0].startTime || !this.timeSlots[0].endTime) {
        alert("No Holiyday date and time");
        return;
      }
      this.showDateHourInput = false;
      this.text_message = "";
      this.show_loading = true;
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("IDn", this.cur_store.IDn);
      let hourArr = {};
      for (let i = 0; i < this.timeSlots.length; i++) {
        if (!this.timeSlots[i].date || !this.timeSlots[i].startTime || !this.timeSlots[i].endTime) {
          break;
        } else {
          if (!hourArr[this.timeSlots[i].date]) {
            hourArr[this.timeSlots[i].date] = [];
          }
          hourArr[this.timeSlots[i].date].push({"starthour": this.timeSlots[i].startTime, "endhour": this.timeSlots[i].endTime});
        }
      }
      bodyFormData.append("hours", JSON.stringify(hourArr));

      var that = this;
      axios({
        method: "post",
        url: "/Api/Web/Store/uberHours",
        data: bodyFormData,
      })
        .then(function (response) {
          that.show_loading = false;
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              if (rt.data && rt.data.message) {
                alert(rt.data.message);
              } else {
                alert("Update no return data");
              }
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          }
        })
        .catch(function (error) {
          that.show_loading = false;
          // console.log(error);
          that.$router.push("/login");
        })
    },
    uber_waiting_connect() {
      this.text_message = "";
      this.show_loading = true;
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("IDn", this.cur_store.IDn);
      var that = this;

      axios({
        method: "post",
        url: "/Api/Web/Store/getOnlineStoreInfo",
        data: bodyFormData,
      })
        .then(function (response) {
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              that.cur_store = rt.data.store;
              if (that.cur_store.SourceParameter && (that.cur_store.SourceParameter.length > 20)) {
                // Go Something. Should means connection OK
                let json = JSON.parse(that.cur_store.SourceParameter);
                if (json.hasOwnProperty("UberEatStoreID")) {
                  that.text_message = "StoreID : " + json.UberEatStoreID;
                } else {
                  that.text_message = "Can not get StoreID ask Posking";
                }
                that.show_loading = false;
              } else {
                that.uber_test_counter++;
                if (that.uber_test_counter > 30) {
                  that.text_message = "Timeout, Please try it later or reload this page.";
                } else {
                  setTimeout(that.uber_waiting_connect, 10000);
                }
              }
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
              that.show_loading = false;
            }
          }
        })
        .catch(function (error) {
          // console.log(error);
          that.$router.push("/login");
        })
    },
    connet_uber(event) {
      if (event) {
        event.preventDefault();
      }
      this.redirct_uri = this.cur_store.SourceURL + "/connectUber?storeId=" + this.cur_store.LocationID;

      // const baseUrl = this.$refs.myForm.action; // Form action URL
      // const queryParams = new URLSearchParams(this.formData).toString();
      // let url = baseUrl+'?'+ queryParams;

      // console.log("Go to R:", this.redirct_uri);
      // console.log("URL:", url);
      this.$refs.myForm.submit();
      this.text_message = "";
      this.show_loading = true;
      setTimeout(this.uber_waiting_connect, 30000);
    },
    async get_api_info(event) {
      if (event) {
        event.preventDefault();
      }
      this.text_message = "";
      this.show_loading = true;
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("IDn", this.cur_store.IDn);
      var that = this;

      axios({
        method: "post",
        url: "/Api/Web/Store/getSourceStoreInfo",
        data: bodyFormData,
      })
        .then(function (response) {
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              if (rt.data && rt.data.message) {
                that.storeDetailContent = rt.data.message;
                that.text_message = "";
                that.showStoreDetailPopup = true;
              } else if (rt.message) {
                that.storeDetailContent = rt.message;
                that.text_message = "";
                that.showStoreDetailPopup = true;
              } else {
                that.text_message = "Unknown return message";
                alert(that.text_message);
              }
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          }
        })
        .catch(function (error) {
          // console.log(error);
          that.$router.push("/login");
        })
        .finally(() => {
          that.show_loading = false;
        });
    },
    async get_store_detail(event) {
      if (event) {
        event.preventDefault();
      }
      this.text_message = "";
      this.show_loading = true;
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("IDn", this.cur_store.IDn);
      var that = this;

      axios({
        method: "post",
        url: "/Api/Web/Store/getUberStoreDetail",
        data: bodyFormData,
      })
        .then(function (response) {
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              if (rt.data && rt.data.info) {
                that.storeDetailContent = JSON.stringify(rt.data.info, null, 2);
                that.text_message = "";
                that.showStoreDetailPopup = true;
              } else if (rt.data && rt.data.message) {
                that.text_message = rt.data.message;
                alert(that.text_message);
              } else {
                that.text_message = "Unknown return data";
                alert(that.text_message);
              }
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              that.text_message = rt.message;
              alert(rt.message);
            }
          }
        })
        .catch(function (error) {
          // console.log(error);
          that.$router.push("/login");
        })
        .finally(() => {
          that.show_loading = false;
        });
    },
    async get_online_list() {
      // this will be called only after form is valid. You can do api call here to login
      this.currpage = "list";
      this.text_message = "";
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("LocationID", this.new_store.LocationID);
      var that = this;
      axios({
        method: "post",
        url: "/Api/Web/Store/getOnlineStoreList",
        data: bodyFormData,
      })
        .then(function (response) {
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              that.storelist = rt.data.stores;
              that.menuList = rt.data.menuList;
              that.Menu_IDn = 0;
              that.tableList = rt.data.tableList;
              that.Table_IDn = 0;
              that.AutoConfirm = 0;
              if (that.storelist.length > 0) {
                let lpara = that.storelist[0].LocalParameter;
                if (lpara) {
                  let lseting = JSON.parse(lpara);
                  if (lseting) {
                    if (lseting.Menu_IDn) {
                      that.Menu_IDn = lseting.Menu_IDn;
                    }
                    if (lseting.Table_IDn) {
                      that.Table_IDn = lseting.Table_IDn;
                    }
                    if (lseting.AutoConfirm) {
                      that.AutoConfirm = lseting.AutoConfirm;
                    }
                  }
                }
              }
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          } else {
            that.$router.push("/login");
          }
        })
        .catch(function (error) {
          that.$router.push("/login");
        });
    },
    async init_data() {
      this.token = getStore("token");
      this.user_id = getStore("user_id");
      if (!this.token || !this.user_id) {
        this.$router.push("/login");
        return;
      }
      this.new_store.LocationID = this.$route.query.LocationID;
      if (!this.new_store.LocationID) {
        this.$router.push("/store");
        return;
      }
      try {
        this.get_online_list();
      } catch (err) {
        console.log("init_data catch", err);
      }
    },
  },
  computed: {
    isIntegrationFormValid() {
      return !!(
        this.integrationForm.email &&
        this.integrationForm.name &&
        this.integrationForm.phone_number &&
        this.integrationForm.pickup_instructions
      );
    },
    isStoreStatusFormValid() {
      if (!this.storeStatusForm.status || !this.storeStatusForm.reason) {
        return false;
      }
      if (this.storeStatusForm.status == "OFFLINE") {
        return !!this.storeStatusForm.is_offline_until;
      }
      return true;
    },
    curTimes() {
      let tms = [];
      if (this.timeSlots && (this.timeSlots.length > 1)) {
        for (let i = 0; i < this.timeSlots.length; i++) {
          tms.push(JSON.parse(JSON.stringify(this.timeSlots[i])));
        }
      }
      return tms;
    },
  },
  mounted() {
    let name = getStore("username");
    if (name && name != undefined && ((name == "PKAdmin") || (name == "posking"))) {
      this.pkadmin = true;
    } else {
      this.$router.push("/store");
      return;
    }

    this.init_data();
    this.windowHeight = window.innerHeight;
  },
};
</script>
<style scoped>
.content {
  padding-top: 80px;
}
.store_radio_div {
  padding-top: 0.5rem;
}
.input_height_1_5 {
  height: 1.5rem;
  padding: 0 0.75rem;
}
.h5-theme-color-field {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.h5-theme-color-input {
  width: 3rem;
  padding: 0 0.15rem;
}
.h5-theme-hex-input {
  max-width: 7rem;
  text-transform: uppercase;
}
.picimg {
  max-height: 14rem;
}
.custom-modal {
  width: 100%;
  min-width: 800px;
}
.store-detail-content {
  max-height: 60vh;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 14px;
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.spinner {
  border: 8px solid rgba(0, 0, 0, 0.1);
  border-top: 8px solid #3498db; /* Change this color as needed */
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

p {
  margin-top: 10px;
  font-size: 18px;
  color: #333; /* Change color as needed */
}
#fp {
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
  border-color: #ced4da !important;
  background-color: white !important;
}
</style>
